import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rooted-device',
  templateUrl: './rooted-device.component.html',
  styleUrls: ['./rooted-device.component.scss']
})
export class RootedDeviceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
